import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { AgenciesService, AgencyDto } from '../../Services/API';
import { QueryKeys } from '../types';

export const useFetchAgenciesByBrandCode = (
  brandCode: string,
  extraOptions?: UseQueryOptions<AgencyDto[], unknown, AgencyDto[], QueryKeys[] | string[]>
) => {
  return useQuery(
    [QueryKeys.fetchAgenciesByBrandCode, brandCode],
    async () => {
      return AgenciesService.agenciesControllerGetAgenciesByBrandCode({ brandCode });
    },
    {
      onError: () => {
        toast.error('Erreur lors de la récupération des agences');
      },
      ...extraOptions,
    }
  );
};
